import * as React from 'react';
import { ArchetypeSpecificStepRunSummaryPanelProps } from '.';

export const CIDistributionStepRunSummaryPanel: React.FC<ArchetypeSpecificStepRunSummaryPanelProps> = ({ stepRun }) => {
    return <div>CI Distribution Step Run Summary Panel - {stepRun.displayName || stepRun.stepId}</div>;
};
